import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import SpecialOffersLayout from './specialOffersLayout';

export default {
  list: SpecialOffersLayout,
  icon: LocalOfferIcon,
};
